import SystemNotificationsFields from './SystemNotificationsFields';
import {doLangFields} from '../../lib/ks-tools';

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.system_notifications_table.fields", SystemNotificationsFields),
            sortOrder: [
                {
                    field: 'startedAt',
                    sortField: 'startedAt',
                    direction: 'desc'
                }
            ],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
